import { ajax } from './createApi'

/**
 *
 *
 * @export 根据车牌号查车
 * @param {*} params   vclNs 车牌号  color: 车牌颜色 (1: 蓝牌 2：黄牌)
 * @returns
 */
export function searchCarvclNs (params) {
  return ajax({
    method: 'POST',
    url: '/truck/api/location/v2/query',
    data: params
  })
}

/**
 *
 *
 * @export 获取用户查车的历史记录
 * @returns
 */
export function getSearchHistoryVcln () {
  return ajax({
    method: 'GET',
    url: '/truck/api/location/hisRecord/USER',
    data: null
  })
}

/**
 *
 *
 * @export 删除用户查车的所有历史记录
 * @param {*} vnoId 所有的车牌id
 * @returns
 */
export function deleteAllHistoryVcln (vnoId) {
  return ajax({
    method: 'POST',
    url: `/truck/api/location/deleteHisRecord/${vnoId}`,
    data: null
  })
}

/**
 *
 * 订阅跨市提醒
 * @export
 * @param {*} params
 */
export function createSpanCityRemind (params) {
  return ajax({
    method: 'POST',
    url: 'spanCityRemind/add',
    data: params,
  })
}

/**
 *
 * 取消跨市提醒
 * @export
 * @param {*} id
 * @returns
 */
export function deleteSpanCityRemind (id) {
  return ajax({
    method: 'GET',
    url: `truck/api/spanCityRemind/delete/${id}`,
    data: null
  })
}

/**
 *
 * 后台统计点击量
 * @export
 * @param {*} data
 * @returns
 */
export function createClickStatistics (data) {
  return ajax({
    method: 'POST',
    url: 'truck/api/statistic/add',
    data
  })
}